import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnChanges,
} from '@angular/core';
import { IMedia } from '@app/shared/interfaces/media.interface';
import {
  MediaImageVariant,
  resolveMediaFileUrl,
  resolveMediaImagePaths,
} from '@app/shared/utils/media.util';
import { environment } from '@environments/environment';

@Directive({
  selector: 'img[pwjMediaImageFallback]',
  standalone: true,
})
export class MediaImageFallbackDirective implements OnChanges {
  @Input({ required: true }) pwjMediaImageFallback!: IMedia;
  @Input() pwjMediaImageFallbackFrom: MediaImageVariant = 'cropped_thumbnail';

  private readonly el = inject(ElementRef<HTMLImageElement>);

  private paths: string[] = [];
  private currentIndex = 0;
  private exhausted = false;

  ngOnChanges() {
    this.reset();
  }

  @HostListener('error')
  onImageError() {
    if (this.exhausted || this.paths.length === 0) {
      return;
    }

    const nextIndex = this.currentIndex + 1;
    if (nextIndex >= this.paths.length) {
      this.exhausted = true;
      return;
    }

    this.currentIndex = nextIndex;
    const nextSrc = resolveMediaFileUrl(
      this.paths[this.currentIndex],
      environment.baseUrl.file
    );

    if (!nextSrc) {
      this.exhausted = true;
      return;
    }

    this.el.nativeElement.src = nextSrc;
  }

  private reset() {
    this.paths = resolveMediaImagePaths(this.pwjMediaImageFallback);
    const startPath =
      this.pwjMediaImageFallback[this.pwjMediaImageFallbackFrom]?.trim();
    const startIndex = startPath
      ? this.paths.findIndex(
          path => path.toLowerCase() === startPath.toLowerCase()
        )
      : 0;

    this.currentIndex = startIndex >= 0 ? startIndex : 0;
    this.exhausted = false;
  }
}
